import React, { useContext, useState, FormEvent, useEffect } from "react";
import {
  Tab,
  Grid,
  Button,
  Table,
  Label,
  Form,
  Input,
  Select,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { IProjectVendor } from "../../../app/models/projectvendor";
import MobileStore from "../../../app/stores/mobileStore";
import MobileVendorEditForm from "./MobileVendorEditForm";

const MobileVendorTab = () => {
  const mobileStore = useContext(MobileStore);
  const {
    projectvendorsByName: projectvendorsByName,
    project,
    selectedProjectVendor,
    loadProjectVendors: loadProjectVendors,
    createProjectVendor,
    deleteProjectVendor,
    selectProjectVendor,
    loadThirdParties,
    ThirdPartiesByName,
    submitting,
    editMode,
    target,
  } = mobileStore;

  useEffect(() => {
    loadThirdParties();
  //  loadProjectVendors(project!.id);
  }, []);

  const initializeForm: IProjectVendor = {
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: project!.id,
    type: "Vendor",
    companyName: "",
    status: "",
    attachment: "",
    remark: "",
    phone: "",
    email: "",
  };

  const [projectvendor, setProjectVendor] = useState<IProjectVendor>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: project!.id,
    type: "Vendor",
    companyName: "",
    status: "",
    attachment: "",
    remark: "",
    phone: "",
    email: "",
  });

  const venderOptions = ThirdPartiesByName.map(function (aa) {
    var option = {
      key: aa.companyName,
      text: aa.companyName,
      value: aa.companyName,
    };
    return option;
  });

  const handleSubmit = () => {
    createProjectVendor(projectvendor)
      .then(() => loadProjectVendors(projectvendor.projectId))
      .then(() => initializeForm && setProjectVendor(initializeForm));
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectVendor({ ...projectvendor, [name]: value });
  };

  const status = [
    { key: "Applied", text: "Applied", value: "Applied" },
    { key: "Approved", text: "Approved", value: "Approved" },
    { key: "Booking", text: "Booking", value: "Booking" },
    { key: "Booked", text: "Booked", value: "Booked" },
  ];

  return (
    <Tab.Pane>
      <Grid>
        <Grid.Column width={16}>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Field inline>
                <label>Vendor Name</label>
                <Select
                  required
                  onChange={(e, { name, value }) =>
                    setProjectVendor({ ...projectvendor, [name]: value })
                  }
                  options={venderOptions}
                  search
                  name="companyName"
                  placeholder="Vendor Name"
                  value={projectvendor.companyName}
                />
              </Form.Field>
              <Form.Field inline>
                <label>Status</label>
                <Select
                  required
                  onChange={(e, { name, value }) =>
                    setProjectVendor({ ...projectvendor, [name]: value })
                  }
                  options={status}
                  search
                  name="status"
                  placeholder="Status"
                  value={projectvendor.status}
                />
              </Form.Field>
              <Form.Field inline>
                <label>Remark</label>
                <Input
                  onChange={handleInputChange}
                  name="remark"
                  placeholder="Remark"
                  value={projectvendor.remark}
                />
              </Form.Field>

              <Button
                loading={submitting}
                floated="right"
                positive
                type="submit"
                content="Add"
              />
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Company Name</Table.HeaderCell>
            <Table.HeaderCell>Phone</Table.HeaderCell>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Attachment</Table.HeaderCell>
            <Table.HeaderCell>Remark</Table.HeaderCell>
            <Table.HeaderCell width={1}>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {projectvendorsByName.map((projectvendor) => (
            <Table.Row key={projectvendor.id}>
              <Table.Cell>
                <Label>{projectvendor.companyName}</Label>
              </Table.Cell>
              <Table.Cell>{projectvendor.phone}</Table.Cell>
              <Table.Cell>{projectvendor.email}</Table.Cell>
              <Table.Cell> {projectvendor.status}</Table.Cell>
              <Table.Cell>{projectvendor.attachment}</Table.Cell>
              <Table.Cell>{projectvendor.remark}</Table.Cell>
              <Table.Cell>
                <Button.Group size="mini">
                  <Button
                    onClick={() => selectProjectVendor(projectvendor.id)}
                    size="mini"
                    content="Edit"
                    color="blue"
                  />
                  <Button
                    name={projectvendor.id}
                    size="mini"
                    loading={target === projectvendor.id && submitting}
                    onClick={(e) => deleteProjectVendor(e, projectvendor.id)}
                    content="Delete"
                    color="red"
                  />
                </Button.Group>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      {selectedProjectVendor && editMode && <MobileVendorEditForm />}
    </Tab.Pane>
  );
};

export default observer(MobileVendorTab);
